import gql from 'graphql-tag';
import { TransactionAmountType } from '@libs/backend-common';
import { TypedDocumentNode } from '@apollo/client';

import { CurrencyType } from '@libs/types';
import {
  DefaultArg,
  DefaultApiResponse,
  transactionErrorFragment,
} from '@libs/graphql';
import { TransactionErrorResponse } from 'src/types';

export type CalculateExchangeNewResp = {
  error?: TransactionErrorResponse;
  toAssetAmountNoFee?: number;
  toAssetAmount: number;
  rate: number;
  fromAssetAmountNoFee?: number;
  fromAssetAmount: number;
  exchangeFeeId?: number;
  disableReset: boolean;
};
export type CalculateExchangeNewArgs = {
  amount: number;
  toAssetCode: CurrencyType;
  fromAssetCode: CurrencyType;

  type: TransactionAmountType;
};

export type CalculateExchangeNewResponse = {
  calculateExchangeNew: DefaultApiResponse<CalculateExchangeNewResp>;
};

export const calculateExchangeNewQuery: TypedDocumentNode<
  CalculateExchangeNewResponse,
  DefaultArg<CalculateExchangeNewArgs>
> = gql`
  query CalculateExchangeNew($record: CalculateExchangeRecord!) {
    calculateExchangeNew(record: $record) {
      toAssetAmountNoFee
      toAssetAmount
      rate
      fromAssetAmountNoFee
      fromAssetAmount
      exchangeFeeId
      error {
        ...transactionErrorFields
      }
      disableReset
    }
  }

  ${transactionErrorFragment}
`;
